import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import CheckTask from "./pages/CheckTask";
import Playable from "./pages/Playable";
import { Switch, Route, Redirect } from "react-router-dom";
import Merge2AccountDeletion from "./pages/account_deletion/Merge2AccountDeletion";
import RareFindAccountDeletion from "./pages/account_deletion/RareFindAccountDeletion";

function App() {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/terms" component={Terms} />
        <Route path="/check-state" component={CheckTask} />
        <Route path="/playable" component={Playable} />
        <Route
          path="/merge-treasure-hunt/account-deletion"
          component={Merge2AccountDeletion}
        />
        <Route
          path="/rare-find/account-deletion"
          component={RareFindAccountDeletion}
        />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    </div>
  );
}

export default App;
